import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CustomTranslateService {
    constructor(private translateService: TranslateService) {}

    /**
     * Check if a translation key exists synchronously
     * @param key The translation key to check
     * @returns True if the translation key exists, false otherwise
     */
    keyExists(key: string): boolean {
        return this.translateService.instant(key) !== key;
    }

    addLangs(langs: string[]): void {
        this.translateService.addLangs(langs);
    }

    get currentLang(): string {
        return this.translateService.currentLang;
    }

    get langs(): string[] {
        return this.translateService.langs;
    }

    /**
     * Subscribe to language change events
     * @returns Observable that emits LangChangeEvent
     */
    get onLangChange(): Observable<LangChangeEvent> {
        return this.translateService.onLangChange;
    }

    setDefaultLang(lang: string): void {
        this.translateService.setDefaultLang(lang);
    }

    use(lang: string): Observable<any> {
        if (lang !== Chathive.widget.getCurrentLanguage()) Chathive.widget.setLanguage(lang);
        return this.translateService.use(lang);
    }

    get(key: string | Array<string>, interpolateParams?: Object): Observable<string | string[]> {
        return this.translateService.get(key, interpolateParams);
    }

    instant(key: string | string[], interpolateParams?: Object): string {
        return this.translateService.instant(key, interpolateParams);
    }
}
